
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "subscribeToNewsletter",
      resolverType: "mutation",
      routePath: "/subscribeToNewsletter",
      httpMethod: "POST",
    });
  